import { Box } from "@mui/material";
import { RHFTextField } from "src/components/hook-form";
import CheckboxTermsAndConditions from "../../../../components/CheckboxTermsAndConditions";
import RHFPhoneInput from "src/components/hook-form/RHFPhoneInput";
import CheckboxAgreeToCampaign from "src/components/CheckboxAgreeToCampaign";
import BookingWaitlistCard from "../booking/BookingWaitlistCard";

const BookingCustomerDataCard = ({
  getHeader,
  translate,
  checkboxValue,
  checkboxCampaignValue,
  handleCheckbox,
  handleCampaignCheckbox,
  isInIframe = false,
  enabledWaitlist = false,
}) => (
  <Box sx={{ paddingX: 4 }}>
    {getHeader(translate("bookings.contactDetails"), "eva:people-fill")}
    <RHFTextField
      label={translate("bookings.fullName")}
      name="fullName"
      sx={{ marginBottom: 2, marginTop: 2 }}
    />
    {/* <RHFTextField
      label={translate("bookings.phoneNumber")}
      name="phoneNumber"
      sx={{ marginBottom: 2 }}
    /> */}
    <RHFPhoneInput
      name="phoneNumber"
      isOverCard={true}
      hideLabel={true}
    />
    <RHFTextField label={translate("bookings.email")} name="email" sx={{ marginY: 1 }} />
    <CheckboxTermsAndConditions
      checkboxValue={checkboxValue}
      handleCheckbox={handleCheckbox}
      isInIframe={isInIframe}
    />
    <CheckboxAgreeToCampaign
      checkboxValue={checkboxCampaignValue}
      handleCheckbox={handleCampaignCheckbox}
    />
    {enabledWaitlist && <BookingWaitlistCard/>}
  </Box>
);

export default BookingCustomerDataCard;
